import type { FC } from 'react';
import React from 'react';
import { useBoolean } from 'ahooks';
import { Button, Input, Modal, Table, message } from 'antd';
import {
  PlusOutlined,
  TagsOutlined,
} from '@ant-design/icons';
import InputVarTypeIcon from '../_base/components/input-var-type-icon';
import { InputVarType } from '../../types';
import type { AssignmentNodeType } from './types';
import type { InputVar, NodePanelProps, MoreInfo } from '../../types';
import { useWorkflowStore } from '../../store';
import useConfig from './use-config';
import Field from '../_base/components/field';
import TagList from './components/tag-list';
import TagExist from './components/tag-exist';
import { DafaModal } from './components/BusScen'
import { RoleModal } from './components/station-role'
import CrudList from './components/crud-list';
import useNodeExistTag from './use-node-tag';

const Panel: FC<NodePanelProps<AssignmentNodeType>> = ({ id, data }) => {
  const { crudDatas: existList } = useNodeExistTag();
  const [
    isShowBusiness,
    { setTrue: showAddVarModal, setFalse: hideAddVarModal },
  ] = useBoolean(false);
  const workflowStore = useWorkflowStore();
  const { prjData } = workflowStore.getState()

  const { readOnly, inputs, handleAddData, handleInfoListChange, handleHashChange, handleCrudListChange } = useConfig(
    id,
    data,
  );
  const { detail } = inputs;
  return (
    <div className="mt-2">
      <div className="space-y-4 px-4 pb-2">
        <Field className='hidden' title="编号（限制输入数字）">
          <div
            className="flex min-h-8 cursor-pointer items-center justify-between rounded-lg border border-gray-200 bg-white pr-2.5 shadow-xs hover:shadow-md"
          >
            <div className="flex w-0 grow items-center space-x-1 bg-components-input-bg-normal rounded-lg">
              <Input
                value={inputs.hash}
                onChange={(e) =>
                  {
                    const numValue = e.target.value.replace(/[^0-9]/g, ''); // 只保留数字
                    // 2. 限制最多 3 位数
                    if (numValue.length <= 3) {
                      handleHashChange(numValue)
                    } else {
                      // 超出 3 位数时提示（可选）
                      message.warning("最多只能输入 3 位数字！");
                    }
                  }
                }
                
                bordered={false}
                allowClear
              />
            </div>
            <div className="ml-2 flex shrink-0 items-center">
              <InputVarTypeIcon
                type={InputVarType.number}
                className="h-3.5 w-3.5 text-gray-500"
              />
            </div>
          </div>
        </Field>
        <Field title="岗位">
          <RoleModal
            value={detail.station}
            onChange={(value) =>
              handleInfoListChange({
                ...detail,
                station: value,
              })
            }
          />
          {/* <div
            className="flex min-h-8 cursor-pointer items-center justify-between rounded-lg border border-gray-200 bg-white pr-2.5 shadow-xs hover:shadow-md"
          >
            <div className="flex w-0 grow items-center space-x-1 bg-components-input-bg-normal rounded-lg">
              <Input
                value={detail.station}
                onChange={(e) =>
                  handleInfoListChange({ ...detail, station: e.target.value })
                }
                bordered={false}
                allowClear
              />
            </div>
            <div className="ml-2 flex shrink-0 items-center">
              <InputVarTypeIcon
                type={InputVarType.textInput}
                className="h-3.5 w-3.5 text-gray-500"
              />
            </div>
          </div> */}
        </Field>
        {/* <Field title="作业标题">
          <div
            ref={ref}
            className="flex min-h-8 cursor-pointer items-center justify-between rounded-lg border border-gray-200 bg-white pr-2.5 shadow-xs hover:shadow-md"
          >
            <div className="flex w-0 grow items-center space-x-1">
              <Input
                className="bg-components-input-bg-normal"
                value={detail.title}
                onChange={(e) =>
                  handleInfoListChange({ ...detail, title: e.target.value })
                }
                bordered={false}
                allowClear
              />
            </div>
            <div className="ml-2 flex shrink-0 items-center">
              <InputVarTypeIcon
                type={InputVarType.textInput}
                className="h-3.5 w-3.5 text-gray-500"
              />
            </div>
          </div>
        </Field> */}
        {/* <Field title="简述">
          <div
            ref={ref}
            className="flex min-h-8 cursor-pointer items-center justify-between rounded-lg border border-gray-200 bg-white pr-2.5 shadow-xs hover:shadow-md"
          >
            <div className="flex w-0 grow items-center space-x-1">
              <Input.TextArea
                className="bg-components-input-bg-normal w-full rounded-lg"
                value={detail.resume}
                onChange={(e) =>
                  handleInfoListChange({
                    ...detail,
                    resume: e.target.value,
                  })
                }
                bordered={false}
                autoSize
                maxLength={48}
                allowClear
                showCount
              />
            </div>
            <div className="ml-2 flex shrink-0 items-center">
              <InputVarTypeIcon
                type={InputVarType.textInput}
                className="h-3.5 w-3.5 text-gray-500"
              />
            </div>
          </div>
        </Field> */}
        <Field title="数据操作" operations={
          !readOnly ? (
            <Button
              type="text"
              icon={<PlusOutlined />}
              onClick={handleAddData}
            />
          ) : undefined
        }>
          <CrudList 
            readonly={readOnly}
            list={inputs.crudDatas || []}
            existList={existList}
            onChange={handleCrudListChange}
          />
        </Field>
        <Field title="描述">
          <div
            className="flex min-h-8 cursor-pointer items-center justify-between rounded-lg border border-gray-200 bg-white pr-2.5 shadow-xs hover:shadow-md"
          >
            <div className="flex w-0 grow items-center space-x-1 bg-components-input-bg-normal rounded-lg">
              <Input.TextArea
                className="w-full"
                value={detail.desc}
                onChange={(e) =>
                  handleInfoListChange({
                    ...detail,
                    desc: e.target.value,
                  })
                }
                maxLength={120}
                bordered={false}
                autoSize
                showCount
                allowClear
              />
            </div>
            <div className="ml-2 flex shrink-0 items-center">
              <InputVarTypeIcon
                type={InputVarType.textInput}
                className="h-3.5 w-3.5 text-gray-500"
              />
            </div>
          </div>
        </Field>
        {prjData.bfTypeCode == 'TARGET' && <Field title="子流程标签">
          <>
            <div
              className="flex min-h-8 cursor-pointer items-center justify-between rounded-lg border border-gray-200 bg-white shadow-xs hover:shadow-md"
            >
              <div className="flex  w-0 grow items-center space-x-1 bg-components-input-bg-normal rounded-lg">
                <div className="px-[11px] py-[4px] leading-6">
                  <TagList
                    tagList={detail.businessTags}
                    onChange={(value) =>
                      handleInfoListChange({
                        ...detail,
                        businessTags: value,
                      })
                    }
                  />
                </div>
              </div>
              <div
                title="新增标签"
                className="flex h-full shrink-0 items-center py-2 pl-2 pr-2.5"
              >
                <TagsOutlined />
              </div>
            </div>
            <div className="mt-2">
              <TagExist
                nodeId={id}
                tagList={detail.businessTags}
                onChange={(value) =>
                  handleInfoListChange({
                    ...detail,
                    businessTags: value,
                  })
                }
              />
            </div>
          </>
        </Field>}
        <Field title="用户场景关联">
          <DafaModal
            value={detail.bindBusinessScenario}
            onChange={(value) =>
              handleInfoListChange({
                ...detail,
                bindBusinessScenario: value,
              })
            }
          />
        </Field>
      </div>
      <Modal title="变量配置" open={isShowBusiness} onCancel={hideAddVarModal}>
        <Table
          columns={[{ title: "a", dataIndex: "a" }]}
          dataSource={[{ a: "1111" }]}
          rowSelection={{
            type: "radio",
          }}
        ></Table>
      </Modal>
    </div>
  );
};

export default React.memo(Panel);
